(function () {
    "use strict";

    angular.module("app").filter("objectTranslation", ObjectTranslationFilterFactory);

    function ObjectTranslationFilterFactory() {
        return function (object, propertyName, language) {
            if (!object || !propertyName)
                return "";

            const normalizedLanguage = language || "EN";
            const translation = object[propertyName + normalizedLanguage];

            return translation || propertyName;
        };
    }
})();